import { render } from "./SlideBar.vue?vue&type=template&id=d2219f68"
import script from "./SlideBar.vue?vue&type=script&lang=js"
export * from "./SlideBar.vue?vue&type=script&lang=js"

import "./SlideBar.vue?vue&type=style&index=0&id=d2219f68&lang=css"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__